if ($('#app-backups').length) {
    var app_backups_table = $('#app-backups-table').DataTable({
        "processing": true,
        "serverSide": true,
        ajax: {
            url: '/backups',
            dataSrc: 'data'
        },
        columns: [
            {data: 'id'},//0
            {data: 'original_filename'},//1
            {data: 'adv_name'},//2
            {data: 'camp_name'},//3
            {data: 'user_name'},//4
            {data: 'created_at_format'},//5
            {data: 'id'},//6

        ],
        // destroy: true,
        pageLength: user_entries,
        "columnDefs": [
            {
                "targets": 0,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log(cellData);
                    var html = ' <div class="checkbox checkbox-danger backups_check">' +
                        ' <input class="checkbox input_checkbook_backups" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_backups[]" ' +
                        'value="' + rowData.id + '"  data-row="' + row + '" >' +
                        '<label for="' + rowData.id + '"> </label></div>';
                    $(td).html(html);
                }
            },
            {
                "targets": 2,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log('rowData......', rowData);
                    console.log('row......', row);
                    $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                }
            },
            {
                "targets": 3,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                }
            },
            {
                "targets": 6,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html ='';
                    // html += ' <button class="btn btn-primary btn-outline btn-sm preview_worksheet_lines " type="button"  data-id="' + rowData.id + '"><i class="fa fa-eye"></i> Preview </button> ';
                    html+= ' <button class="btn btn-danger btn-outline btn-sm delete_backup" type="button"  data-id="'+rowData.id+'"><i class="fa fa-trash-o"></i> Delete </button> ' ;
                    $(td).html(html);
                }
            },
        ],
        "createdRow": function (row, data, dataIndex) {
            $(row).attr('data-daypart-id', data.id);
        }
    });

    $('#create_backup').on('click', function (){
        $('#advertiser').select2({
            minimumResultsForSearch: 5
        });
        $('#campaign').select2({
            minimumResultsForSearch: 5
        });
        var html = '<option></option>';
        for(var i in advertisers)
            html += '<option value="'+advertisers[i].id+'">'+advertisers[i].name+'</option>';
        $('#advertiser').html();
        $('#advertiser').html(html);
        $('#campaign').html('');
       $('#createBackupModal').modal('show');
    });
    $('#advertiser').on('change', function () {
        if($('#advertiser option:selected').val() != '' && typeof $('#advertiser option:selected').val() != 'undefined') {
            show_overlay_loader($('#createBackupModal .modal-content'));
            var params = {
                advertisers_id: $('#advertiser option:selected').val(),
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/backups/get/campaigns',
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    var html = '<option></option>';
                    for (var i in response)
                        html += '<option value="' + response[i].id + '">' + response[i].name + '</option>';
                    $('#campaign').html(html);

                    hide_overlay_loader($('#createBackupModal .modal-content'));
                },
                error: function (xhr) {
                    ajax_error();
                    hide_overlay_loader($('#createBackupModal .modal-content'));
                    debug(xhr.responseText);
                }
            });
        }
        else
            $('#campaign').html('');

    });

    $('#save_backup').on('click', function(){
        if($('#campaign option:selected').val() != '' && typeof $('#campaign option:selected').val() != 'undefined'){
            init_progress_loader(2, 'This operation could take few seconds. Please wait ...');
            var options = [];
            $('.div_graphs_options input[type=checkbox]').each(function () {
                if (this.checked)
                    options.push($(this).val())
            });
            var params = {
                advertisers_id: $('#advertiser option:selected').val(),
                campaigns_id: $('#campaign option:selected').val(),
                options:options,
                name: $('#name').val(),
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/backups/store',
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    console.log('response', response);
                    saveFile(response.name + ".xml", "data:attachment/xml", response.data);
                    close_progress_loader();
                },
                error: function (xhr) {
                    ajax_error();
                    close_progress_loader();
                    debug(xhr.responseText);
                }
            });
        }
        else{
            swal({
                    title: "Warning",
                    text: "Please select at least one Campaign.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: 'Cancel',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {}

                });
        }

    });
    function saveFile (name, type, data) {
        if (data != null && navigator.msSaveBlob)
            return navigator.msSaveBlob(new Blob([data], { type: type }), name);
        var a = $("<a style='display: none;'/>");
        var url = window.URL.createObjectURL(new Blob([data], {type: type}));
        a.attr("href", url);
        a.attr("download", name);
        $("body").append(a);
        a[0].click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }

    var init_progress_loader = function (steps, message) {
        progress_loader_steps = steps;
        progress_loader_curr_step = 0;

        update_progress_loader(message);

        $('#progressloader').show();
    };

    var close_progress_loader = function () {
        progress_loader_steps = 0;
        progress_loader_curr_step = 0;
        $('#progressloader').hide();
    };

    $('#app-backups-table').on('click', '.delete_backup', function () {
        var id = $(this).attr('data-id');
        swal({
                title: "Warning",
                text: "Are you sure to delete?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "OK",
                cancelButtonText: 'Cancel',
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    $.ajax({
                        type: 'GET',
                        url: '/backups/delete/' + id,
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            $('#app-backups-table').DataTable().ajax.reload();
                            global_notification('success', 'Restored Backup File deleted...');
                        },
                        error: function (xhr) {
                            hide_loader();
                            ajax_error();
                            debug(xhr.responseText);

                        }
                    });
                }
            });

    });

    $('#select_all_backups').on('click', function (e) {
        $('#app-backups-table input:checkbox').prop('checked', true);
    });
    $('#deselect_all_backups').on('click', function (e) {
        $('#app-backups-table input:checkbox').prop('checked', false);
    });
    $('#delete_multiple_backups').on('click', function () {
        var selectedItems = [];
        $('.backups_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push(parseInt($(this).val()));
        });
        if(selectedItems.length > 0){
            swal({
                    title: "Warning",
                    text: 'Are you sure to delete the Restored Backup File(s)?',
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        var url_one = '/backups/delete/multiple';
                        var params = {
                            ids: selectedItems,
                        };
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            data: JSON.stringify(params),
                            url: url_one,
                            dataType: "json",
                            contentType: "application/json",
                            success: function (response) {
                                $('#app-backups-table').DataTable().ajax.reload();
                                global_notification('success', 'Restored Backup File deleted...');
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });
        }
        else {
            swal({
                    title: "Warning",
                    text: 'Select at least one Restored Backup File.',
                    type: "warning",
                     showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Ok",
                      cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                });
        }

    });
}